import React, {Component} from 'react'

class SMSPreview extends Component{
  render(){
    return(
      <div className="sms-preview">
        <div>P</div>
        <p>
          {this.props.content}
        </p>
      </div>
    )
  }
}
export default (SMSPreview)
